var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCongratulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 437,
    viewBox: "0 0 250 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.227 82.1793C180.04 79.6317 176.282 81.0838 175.571 81.415C174.479 84.1664 173.285 86.9432 171.99 89.6946C166.326 101.773 159.523 113.281 151.675 124.061C151.675 124.061 127.221 105.821 118.663 101.133C111.045 96.9806 98.6019 97.4901 98.6019 97.4901C98.4401 96.3146 97.9916 95.1973 97.2961 94.2374C96.6006 93.2774 95.6797 92.5046 94.6151 91.9874L94.0564 91.8345C85.5648 90.1864 76.826 90.3078 68.3832 92.1912L68.0277 92.3695C66.3957 93.6647 65.2716 95.4961 64.8534 97.5411C64.8534 97.5411 44.0812 100.624 38.0121 105.642C32.6285 110.075 10.6628 138.761 6.87912 146.607C3.88264 152.849 0.606829 158.352 1.03853 165.332C1.95271 179.318 18.5095 192.081 36.2599 198.96V199.24C35.5996 213.71 34.6855 224.716 34.1776 234.346H36.9201L131.792 234.193H133.849C133.544 218.525 126.586 168.465 122.015 138.302C122.802 138.684 147.79 152.721 158.455 153.588C163.839 153.995 172.574 130.659 179.075 110.457C183.9 95.4266 187.481 82.2812 187.481 82.2812H187.277L187.227 82.1793ZM103.224 161.154H91.4916L89.9172 171.981H90.3997C90.6675 172.015 90.9258 172.103 91.1596 172.239C91.3932 172.374 91.5977 172.555 91.7608 172.771C91.9239 172.987 92.0425 173.233 92.1097 173.496C92.1768 173.758 92.1912 174.031 92.1519 174.299L91.644 183.623L91.4155 187.649C91.7952 187.625 92.1759 187.677 92.5351 187.803C92.8942 187.93 93.2244 188.127 93.5062 188.383C93.788 188.64 94.0156 188.951 94.1755 189.297C94.3355 189.643 94.4245 190.018 94.4373 190.4C94.299 191.253 93.9656 192.063 93.4634 192.766C92.9612 193.469 92.3037 194.045 91.5424 194.451C91.8782 194.4 92.2207 194.418 92.5495 194.503C92.8782 194.588 93.1867 194.739 93.4566 194.945C93.7265 195.152 93.9523 195.411 94.1208 195.706C94.2893 196.002 94.3969 196.329 94.4373 196.667C94.2888 197.445 93.9549 198.176 93.4641 198.797C92.9733 199.418 92.3402 199.911 91.6186 200.234C91.933 200.131 92.2669 200.103 92.594 200.151C92.9211 200.2 93.2324 200.325 93.5033 200.515C93.7742 200.705 93.9974 200.956 94.155 201.248C94.3127 201.539 94.4007 201.864 94.4119 202.195C94.4119 203.393 92.6852 204.947 89.5871 206.017L90.2981 206.297L89.9934 211.978C90.0089 212.473 89.8368 212.956 89.5117 213.33C89.1866 213.703 88.7327 213.939 88.2412 213.99H76.0267C75.5352 213.939 75.0813 213.703 74.7562 213.33C74.4312 212.956 74.2591 212.473 74.2746 211.978L73.9952 206.883V206.603C71.0329 206.004 68.1273 205.152 65.3105 204.055H64.5741C67.1135 202.221 66.3263 190.935 66.3263 190.935C66.0469 189.687 69.0434 186.528 72.5732 186.273H72.8017L72.6494 183.114L72.4716 179.038C71.2302 178.961 70.037 178.527 69.0348 177.788C68.0325 177.049 67.2636 176.037 66.82 174.871C66.3764 173.705 66.2768 172.436 66.5331 171.215C66.7894 169.994 67.3909 168.873 68.2655 167.986C69.1401 167.098 70.2509 166.483 71.4651 166.212C72.6792 165.941 73.9454 166.027 75.1122 166.46C76.279 166.892 77.2971 167.652 78.0447 168.649C78.7923 169.646 79.2378 170.838 79.3279 172.083H86.4129L88.5205 157.868H103.478L103.224 161.154Z",
    fill: "#111747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.975 420.226C145.959 418.894 131.829 411.945 128.41 411.684H127.676C126.08 412.128 107.695 411.684 107.695 411.684C107.695 411.684 107.695 411.292 107.695 411.031V431.197L166.168 430.936C167.307 423.909 162.293 420.853 156.975 420.226Z",
    fill: "#111747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0996 419.755C41.3964 419.979 41.0151 413.868 31.7612 409.297L31.3291 409.073L14.1433 402.391H13.8383L5.80469 418.463L30.7698 429.965L61.5566 430.238V429.468C60.7939 425.295 54.2349 419.382 46.0996 419.755Z",
    fill: "#111747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 436H166.336V431.199H107.7V436Z",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7677 199.144C35.1056 213.653 34.189 224.689 33.6797 234.345L133.649 234.166C133.318 215.62 123.642 149.05 119.593 123.914",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7578 409.114C38.3934 403.649 89.0054 314.731 100.006 254.512",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5698 234.344C33.4938 292.216 13.5 401.43 13.5 401.43",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5078 297.782C92.2348 323.726 106.114 403.316 107.446 411.812C107.446 411.812 127.159 412.219 127.385 411.812C130.704 404.486 132.992 326.779 130.955 234.344",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8685 247.789C51.3074 261.59 37.6059 265.712 25.0312 263.587",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.479 411.992C131.896 412.25 146.022 419.098 157.034 420.411C162.35 421.028 167.362 424.041 166.147 430.94L107.695 431.197",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.695 411.031V430.237",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 423.656L29.5513 435.039L61.5575 434.797V430.195L30.6725 429.929L5.64852 418.715L2.92188 423.656Z",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5954 429.277C59.9446 424.94 53.4869 418.904 45.5774 419.285C40.8717 419.513 40.5714 413.071 31.0349 408.379L13.7142 401.43L5.80469 417.839",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2109 37.0469C70.9826 31.2991 72.0032 22.7913 75.9363 18.3349C88.5322 4.00335 103.169 33.1982 105.509 42.5922C107.725 51.3531 95.5521 71.1033 92.0671 72.5213C86.7897 74.6482 79.2969 69.6094 76.9321 64.6212",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2891 92.2269C68.2891 77.0066 68.2891 63.2236 68.2891 48.0547",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3984 73.0195C91.2642 79.4046 92.2493 86.8413 95.2046 92.2248",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1283 40.4003C64.8825 29.8964 59.5065 43.7146 62.3114 47.3349C64.1034 49.6549 67.947 49.2215 70.1026 48.1252",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3366 25.4935C98.2175 25.4935 118.996 21.3753 116.068 15.7129C112.752 9.22681 72.6722 29.6888 70.2109 30.7698",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5878 41.5389C84.614 41.3199 83.584 41.274 82.5816 41.4049C81.5793 41.5359 80.6331 41.8399 79.8203 42.2923",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2903 42.293C67.2608 42.8938 65.8854 43.2373 64.4453 43.2532",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6644 48.0533C84.1952 48.0533 84.6256 47.6234 84.6256 47.0931C84.6256 46.5627 84.1952 46.1328 83.6644 46.1328C83.1335 46.1328 82.7031 46.5627 82.7031 47.0931C82.7031 47.6234 83.1335 48.0533 83.6644 48.0533Z",
    fill: "#111747"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0862 47.0924C98.6171 47.0924 99.0475 46.6625 99.0475 46.1321C99.0475 45.6018 98.6171 45.1719 98.0862 45.1719C97.5554 45.1719 97.125 45.6018 97.125 46.1321C97.125 46.6625 97.5554 47.0924 98.0862 47.0924Z",
    fill: "#111747"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.01 41.7482C98.2839 40.989 94.3605 41.2168 93.6543 42.8615C92.5557 45.3919 94.2297 51.0093 94.9359 54.1722C95.4067 56.3231 96.2176 60.5235 92.3203 59.3848",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.946 81.6641C169.697 96.6594 161.695 110.872 152.104 124.007C152.104 124.007 127.601 105.896 119.026 101.242C111.392 97.1191 98.9245 97.625 98.9245 97.625C98.7337 96.3542 98.1999 95.1585 97.38 94.1653C96.5601 93.172 95.4846 92.4183 94.2681 91.9843C85.7187 89.6572 70.0956 91.3266 68.1618 92.5155C66.5265 93.8014 65.4002 95.6198 64.9812 97.6503C64.9812 97.6503 44.1674 100.711 38.0861 105.694C32.6919 110.095 10.7076 138.577 6.89089 146.368C3.88841 152.565 0.606042 158.029 1.0386 164.959C2.43806 186.434 41.3685 205.026 64.2433 203.534C67.3985 203.331 66.6351 190.279 66.6351 190.279C58.3402 188.281 24.4478 172.573 29.2314 164.605C38.2413 152.519 48.4725 141.382 59.7651 131.368",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.478 71.0985C187.215 65.8806 187.188 62.1238 187.294 57.4799C187.294 55.8884 188.137 49.3661 185.028 50.0183C181.919 50.6706 182.762 64.9675 182.815 67.1851",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.635 51.819C183.352 49.9645 182.583 48.9871 180.864 49.0122C177.067 49.0122 177.991 61.5428 177.914 67.2568",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M186.775 82.6154C190.171 82.9685 192.1 71.2666 192.273 67.6602C192.273 66.4749 192.503 64.2808 190.805 63.5494C189.653 63.0702 188.674 64.0033 188.272 64.7095C187.742 65.7934 187.402 66.9413 187.264 68.1142C187.034 69.6273 186.717 71.4431 186.516 72.9563",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M178.283 51.1327C177.987 49.5219 176.261 49.7817 175.155 50.743C171.972 53.497 172.835 72.8788 174.993 81.9202C174.993 81.9202 178.985 79.7118 187.481 82.6217",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.117 138.449C122.903 138.83 147.852 152.787 158.501 153.675C167.908 154.436 187.482 82.6211 187.482 82.6211",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5514 171.926H73.879C73.6145 171.957 73.3588 172.042 73.1275 172.177C72.8962 172.312 72.6941 172.493 72.5332 172.71C72.3723 172.927 72.2561 173.175 72.1916 173.438C72.127 173.702 72.1155 173.977 72.1577 174.246L72.931 189.211",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5039 188.25L92.2986 174.254C92.3397 173.985 92.3247 173.711 92.2546 173.447C92.1846 173.184 92.0608 172.936 91.8906 172.719C91.7205 172.503 91.5072 172.321 91.2634 172.185C91.0196 172.048 90.7501 171.96 90.4707 171.926H89.4375",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0547 206.937L74.3329 212.128C74.3175 212.633 74.489 213.125 74.8128 213.505C75.1366 213.886 75.5888 214.126 76.0784 214.178H88.3468C88.8388 214.132 89.2945 213.893 89.6195 213.512C89.9445 213.13 90.1138 212.634 90.0922 212.128L90.3958 206.496",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0938 188.636C74.5186 192.962 81.8925 192.237 85.0921 191.646C86.2669 191.431 91.8911 188.959 91.3162 187.293",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1319 187.299C91.5224 187.274 91.9139 187.329 92.2832 187.461C92.6525 187.593 92.992 187.8 93.2818 188.069C93.5715 188.338 93.8056 188.664 93.97 189.027C94.1345 189.39 94.226 189.783 94.2392 190.183C94.0303 194.242 86.7712 197.9 78.8594 196.645",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4 194.042C91.7293 193.987 92.0651 194.007 92.3876 194.1C92.71 194.192 93.0125 194.356 93.2772 194.581C93.5418 194.807 93.7633 195.089 93.9285 195.411C94.0937 195.734 94.1993 196.09 94.2389 196.459C94.0397 200.153 87.3658 203.57 79.8203 202.431",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4803 199.888C91.7913 199.776 92.1216 199.746 92.4452 199.799C92.7687 199.851 93.0767 199.986 93.3447 200.192C93.6127 200.397 93.8334 200.669 93.9893 200.984C94.1453 201.299 94.2323 201.65 94.2435 202.009C94.2435 205.397 82.8141 211.319 65.4062 203.854",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4139 191.133C65.9702 189.933 68.7489 186.613 72.1346 186.332",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1328 182.914C78.1616 180.866 79.1189 186.902 87.1142 186.285C88.0245 186.155 88.8849 185.841 89.6233 185.37C90.3617 184.898 90.9564 184.283 91.3576 183.575",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1525 186.331L90.8702 160.92L102.634 160.869L102.889 157.523H87.891L83.6641 186.025",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6153 178.648C71.3795 178.648 70.1715 178.281 69.144 177.596C68.1165 176.91 67.3157 175.935 66.8428 174.794C66.3699 173.654 66.2462 172.399 66.4872 171.188C66.7283 169.977 67.3234 168.865 68.1972 167.992C69.071 167.119 70.1843 166.525 71.3963 166.284C72.6083 166.043 73.8646 166.167 75.0063 166.639C76.148 167.112 77.1238 167.912 77.8103 168.938C78.4969 169.965 78.8633 171.171 78.8633 172.406",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7949 200.499C43.4451 203.801 53.6746 205.12 63.8578 204.376C67.0549 204.172 66.2814 191.009 66.2814 191.009C57.8762 188.994 23.5332 173.153 28.3804 165.117C37.5101 152.928 47.8774 141.697 59.32 131.598",
    stroke: "white",
    strokeWidth: 0.86,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8951 68.215C83.8855 68.0438 81.8066 60.5863 83.059 61.5888C84.8718 62.5298 86.8849 63.0441 88.9376 63.0908C90.9903 63.1375 93.0257 62.7153 94.8815 61.8577C96.2592 61.1242 92.9528 68.3861 88.8951 68.215Z",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M171.672 89.364L149.887 99.9073L158.856 77.6947L140.383 68.0983L165.404 56.5058L144.052 36.3917L172.36 41.2027L162.678 10.4941L186.476 32.0925L194.859 1L203.241 32.0925L221.383 19.7322L217.357 41.2027L249.003 35.931L224.313 56.5058L242.225 66.8955L221.943 73.1908L239.83 99.9073L217.306 88.9545",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M216.316 89.3438L205.857 110.2L194.016 95.2806L178.828 117.191L178.93 110.2",
    stroke: "#111747",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulation);
export default __webpack_public_path__ + "static/media/congratulation.c338b9ce548e3f4df1f609b7f8fc76f7.svg";
export { ForwardRef as ReactComponent };